import myaxios from '@/libs/my-request'

/**
 * 用户登录
 * @param {Object} data - 登录信息
 * @returns {Promise} 返回登录结果
 */
export const login = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/login',
    data
  })
}

/**
 * 用户注册
 * @param {Object} data - 注册信息
 * @param {string} data.tel - 手机号
 * @param {string} data.user_name - 用户名
 * @param {string} data.pwd - 登录密码
 * @param {string} data.security_password - 资金密码（提现密码）
 * @param {string} data.invite_code - 邀请码（条件必填）
 * @returns {Promise} 返回注册结果
 */
export const register = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/register',
    data
  })
}

/**
 * 获取首页数据
 * @returns {Promise} 返回首页数据
 */
export const getHomeData = () => {
  return myaxios({
    method: 'get',
    url: '/api/home/index'
  })
}

/**
 * 获取订单列表
 * @param {Object} data - 查询参数
 * @returns {Promise} 返回订单列表
 */
export const getOrderList = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/order_list',
    data
  })
}

/**
 * 下单
 * @param {Object} data - 订单信息
 * @returns {Promise} 返回下单结果
 */
export const doOrder = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/order/do_order',
    data
  })
}

/**
 * 提交订单
 * @param {Object} data - 订单数据
 * @returns {Promise} 返回提交结果
 */
export const submitOrder = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/order/submit_order',
    data
  })
}

/**
 * 获取订单详情
 * @param {Object} data - 订单ID
 * @returns {Promise} 返回订单详情
 */
export const orderInfo = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/order/order_info',
    data
  })
}

/**
 * 获取抢单数据
 * @returns {Promise} 返回抢单列表
 */
export const getGrabbingData = () => {
  return myaxios({
    method: 'get',
    url: '/api/order/api_index'
  })
}

/**
 * 获取服务数据
 * @returns {Promise} 返回服务信息
 */
export const getServiceData = () => {
  return myaxios({
    method: 'get',
    url: '/api/user/service'
  })
}

/**
 * 获取登录页
 * @returns {Promise} 返回服务信息
 */
export const getLoginServiceData = () => {
  return myaxios({
    method: 'get',
    url: '/api/home/kefu'
  })
}

/**
 * 充值
 * @param {Object} data - 充值信息
 * @returns {Promise} 返回充值结果
 */
export const doRecharge = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/recharge',
    data
  })
}

/**
 * 充值访问记录
 * @param {Object} data - 充值访问信息
 * @returns {Promise} 返回结果
 */
export const rechargeVisit = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/recharge_visit',
    data
  })
}

/**
 * 获取充值列表
 * @returns {Promise} 返回充值列表
 */
export const getRechargeList = () => {
  return myaxios({
    method: 'get',
    url: '/api/user/recharge_list'
  })
}

/**
 * 获取充值记录
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回充值记录列表
 */
export const getRechargeLog = (params) => {
  return myaxios({
    method: 'get',
    url: '/api/user/recharge_log',
    params
  })
}

/**
 * 获取提现记录
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回提现记录列表
 */
export const getWithdrawLog = (params) => {
  return myaxios({
    method: 'get',
    url: '/api/user/withdraw_log',
    params
  })
}

/**
 * 获取余额明细
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回余额明细列表
 */
export const getBalanceLog = (params) => {
  return myaxios({
    method: 'get',
    url: '/api/user/balance_log',
    params
  })
}

/**
 * 获取团队信息
 * @returns {Promise} 返回团队信息
 */
export const getTeamInfo = () => {
  return myaxios({
    method: 'get',
    url: '/api/user/team_info'
  })
}

/**
 * 获取团队列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回团队成员列表
 */
export const getTeamList = (params) => {
  return myaxios({
    method: 'get',
    url: '/api/user/team_list',
    params
  })
}

/**
 * 获取银行卡信息
 * @returns {Promise} 返回银行卡信息
 */
export const getBankInfo = () => {
  return myaxios({
    method: 'get',
    url: '/api/user/get_bank_info'
  })
}

/**
 * 绑定银行卡
 * @param {Object} data - 银行卡信息
 * @param {string} data.paypassword - 提现密码
 * @param {string} data.bankname - 银行名称
 * @param {string} data.username - 真实姓名
 * @param {string} data.cardnum - 银行卡号
 * @returns {Promise} 返回绑定结果
 */
export const bindBank = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/bind_bank',
    data
  })
}

/**
 * 提现
 * @param {Object} data - 提现信息
 * @param {string} data.paypassword - 提现密码
 * @param {number} data.num - 提现金额
 * @returns {Promise} 返回提现结果
 */
export const withdraw = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/withdraw',
    data
  })
}

/**
 * 获取用户信息
 * @returns {Promise} 返回用户信息
 */
export const getUserInfo = () => {
  return myaxios({
    method: 'get',
    url: '/api/user/info'
  })
}

/**
 * 修改登录密码
 * @param {Object} data - 密码信息
 * @param {string} data.old_pwd - 旧密码
 * @param {string} data.new_pwd - 新密码
 * @returns {Promise} 返回修改结果
 */
export const changePassword = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/change_password',
    data
  })
}

/**
 * 修改提现密码
 * @param {Object} data - 密码信息
 * @param {string} data.old_pwd - 旧提现密码
 * @param {string} data.new_pwd - 新提现密码
 * @returns {Promise} 返回修改结果
 */
export const changePayPassword = (data) => {
  return myaxios({
    method: 'post',
    url: '/api/user/change_paypassword',
    data
  })
}
